/* eslint-disable */

import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DropzoneS3Uploader from 'react-dropzone-s3-uploader';
import styled from 'styled-components';
import { Button, Header, Form, Progress, Modal } from 'semantic-ui-react';

import { Loader } from '../../components/share';
import { getTags, insertTag } from '../../services/TagService';
import { getIdToken } from '../../services/ServiceManager';

import domains from '../../containers/Domains';
import * as AppActions from '../../actions';
import { api as apiBuilder } from '../../utils/apiBuilder';

const Container = styled.div`
  max-width: 100%;
`;
const Title = styled.h1`
  margin-bottom: 20px;
  color: #111;
`;
const Center = styled.div`
  height: 100%;
`;
const CenterPreview = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const IframeContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const IframeContent = styled.div`
  flex: 1;
`;
const DropMessage = styled.p`
  font-size: 28px;
  color: #ccc;
`;
const DropContainer = styled.div`
  margin: 0 auto;
`;
const IframeHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  margin-bottom: 30px;
`;
const IframeHeaderTitle = styled.h2`
  margin: 0 10px 0 0;
`;
const TextTitle = styled.span`
  color: #121212;
  font-size: 18px;
`;
const TextContent = styled.span`
  color: #121212;
  font-size: 16px;
`;

class AdImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      screen: 'zip',
      title: '',
      tag: null,
      percentage: 0,
      error: null,
      tags: [],
      selectedTags: {},
      oem: [],
      account: [],
      product: [],
      uploadOptions: null,
      errors: {
        title: false,
        product: false,
        client: false,
        oem: false
      },
      confirm: false,
      width: 0,
      height: 0
    };
  }

  componentDidMount() {
    getIdToken().then((result) => {
      if (!result || result === '') {
        throw new Error('AlexiaAuth token cannot be generated.');
      }

      const uploadOptions = {
        ...this.props.adImport.uploadOptions,
        Accept: 'application/json',
        'Content-Type': 'text/plain',
        uploadRequestHeaders: {
          'x-amz-acl': 'public-read',
          AlexiaAuth: result
        },
        signingUrlHeaders: { AlexiaAuth: result }
      };

      this.setState((prevState) => ({
        ...prevState,
        uploadOptions
      }));

      this.getTagsOptions();
      window.addEventListener('message', this.getDimensions, false);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.getDimensions, false);
  }

  getDimensions = (result) => {
    const { width, height } = result.data;
    this.setState({ width, height });
  };

  toggleConfirm = () => {
    this.setState({ confirm: !this.state.confirm });
  };

  onConfirm = () => {
    this.onClear();
  };

  getTagsOptions = async () => {
    const result = await getTags();
    const tags = _.sortBy(result.tags, 'value');
    tags.map((tag, index) => {
      if (this.state[tag.category])
        this.state[tag.category].push({
          key: index,
          value: tag.id,
          text: tag.value,
          category: tag.category
        });
    });
  };

  allRequired = () => {
    let res = true;
    let errors = this.state.errors;

    if (this.state.title.length === 0) {
      res = false;
      errors['title'] = true;
    } else {
      errors['title'] = false;
    }

    this.setState({ errors });
    return res;
  };

  onSubmit = async () => {
    try {
      if (this.allRequired()) {
        const { actions } = this.props;
        const payload = {
          title: this.state.title,
          product: this.state.selectedTags['product'] || '',
          client: this.state.selectedTags['account'] || '',
          oem: this.state.selectedTags['oem'] || '',
          file_name: this.state.fileName,
          html_url: this.props.adImport.htmlUrl,
          html_width: this.state.width,
          html_height: this.state.height
        };

        await actions.newAdImport(payload);
        if (this.props.adImport.importId) {
          this.toggleConfirm();
        } else {
          this.onClear();
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  loadPreview = async (file) => {
    try {
      //below are the new changes so that apibuilder can be used for this
      const operation = 'import/ad';
      const endpoint = apiBuilder.buildApi(operation);
      const { actions } = this.props;
      await actions.fetchAdHtml(
        //domains[window.location.hostname],
        endpoint,
        file.filename
      );
      this.setState({
        screen: 'preview',
        error: null,
        fileName: file.filename
      });
    } catch (err) {
      console.log(err);
    }
  };

  onProgress = (percentage) => {
    this.setState({ percentage });
  };

  onDropRejected = (data) => {
    if (data[0].size > 50000000) {
      this.setState({ error: 'The max size file must be 50Mb' });
    } else {
      this.setState({ error: 'File must be a zip type' });
    }
  };

  onTagSelect = (e, data) => {
    const tag = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    if (!tag) {
      return;
    }

    let selectedTags = this.state.selectedTags;
    selectedTags[tag.category] = tag.value;

    this.setState({ selectedTags });
  };

  onTagsSelect = (e, data) => {
    const tags = [];
    data.value.map((val) => {
      const tag = _.find(data.options, (option) => {
        return option.value === val;
      });

      if (tag) {
        tags.push(tag);
      }
    });
    let selectedTags = this.state.selectedTags;
    selectedTags[data.id] = data.value;

    this.setState({ selectedTags });
  };

  addTag = async (e, data) => {
    const existingTag = this.state[data.id].find(
      (item) => item.category === data.id && item.text === data.value
    );

    if (!existingTag) {
      const result = await insertTag({
        value: data.value,
        category: data.id,
        required: false
      }); // response structure changed in ALEXIA-1400

      // the result.tag might be null if there is duplicated tags already in the db.
      const { statusCode, tag } = result;

      if (statusCode === 200 && tag) {
        const newTag = {
          key: this.state[data.id].length,
          value: tag.id,
          text: data.value,
          category: data.id
        };
        this.state[data.id].push(newTag);

        let newValues = [tag.id];
        newValues = newValues.concat(this.state.selectedTags[data.id]);
        this.onTagsSelect(null, {
          id: data.id,
          value: newValues,
          options: data.options
        });
      } else {
        this.onClear();
      }
    }
  };

  onClear = () => {
    this.setState({
      title: '',
      screen: 'zip',
      percentage: 0,
      confirm: false,
      tags: [],
      selectedTags: {},
      errors: {
        title: false,
        product: false,
        client: false,
        oem: false
      }
    });
  };

  renderIframe = () => {
    return {
      __html: this.props.adImport.preview
    };
  };

  renderContent = () => {
    if (this.props.adImport.loading) {
      return <Loader inverted active />;
    }

    if (this.state.screen === 'preview') {
      const { htmlUrl } = this.props.adImport;
      const { sandboxVar } = 'allow-scripts';
      const { width, height } = this.state;
      return (
        <CenterPreview>
          <Form className="ad-import-form" onSubmit={this.onSubmit}>
            <Form.Group>
              <Form.Input
                placeholder="Title"
                onChange={(ev) => this.setState({ title: ev.target.value })}
                value={this.state.title}
                width={13}
                error={this.state.errors['title']}
              />
              <Form.Button secondary fluid width={3}>
                Save
              </Form.Button>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Dropdown
                search
                selection
                allowAdditions
                id="account"
                value={this.state.selectedTags['account']}
                options={this.state.account}
                placeholder="Client"
                onChange={this.onTagSelect}
              />
              <Form.Dropdown
                search
                selection
                allowAdditions
                multiple
                id="product"
                value={this.state.selectedTags['product']}
                options={this.state.product}
                placeholder="Product"
                onChange={this.onTagsSelect}
                onAddItem={this.addTag}
              />
              <Form.Dropdown
                search
                selection
                allowAdditions
                id="oem"
                value={this.state.selectedTags['oem']}
                options={this.state.oem}
                placeholder="OEM"
                onChange={this.onTagSelect}
              />
            </Form.Group>
          </Form>
          {this.props.adImport.preview && (
            <IframeContainer className="iframe-import-ad">
              <IframeHeader>
                <IframeHeaderTitle>Preview</IframeHeaderTitle>
                <Button onClick={() => this.onClear()} secondary>
                  Clear
                </Button>
              </IframeHeader>
              <IframeContent id="iframe-container">
                <iframe
                  src={this.props.adImport.htmlUrl}
                  sandbox="allow-scripts"
                  src={htmlUrl}
                  sandbox={sandboxVar}
                  height={height}
                  width={width}
                />
              </IframeContent>
            </IframeContainer>
          )}
        </CenterPreview>
      );
    }

    const { uploadOptions } = this.state;

    return (
      <Center>
        <DropContainer>
          <DropzoneS3Uploader
            accept="application/zip"
            onFinish={this.loadPreview}
            s3Url={this.props.adImport.s3Url}
            upload={uploadOptions}
            progressComponent={<Loader inverted active />}
            onProgress={this.onProgress}
            maxSize={50000000}
            onDropRejected={this.onDropRejected}
            onError={(e) => {
              console.log('error', e);
            }}
          >
            <DropMessage>Drop or select your zip here.</DropMessage>
          </DropzoneS3Uploader>
          {this.state.error && (
            <Header as="h3" color="red" textAlign="center">
              {this.state.error}
            </Header>
          )}
          {this.state.percentage > 0 && (
            <Progress percent={this.state.percentage} progress indicating />
          )}
        </DropContainer>
      </Center>
    );
  };

  render() {
    return (
      <Container className="container ad-import-container">
        <Title>Display Ad Import</Title>
        {this.renderContent()}
        <Modal
          className="modalAdImport"
          size="small"
          closeOnEscape
          closeOnDimmerClick={false}
          open={this.state.confirm}
          onClose={this.toggleConfirm}
        >
          <Modal.Header>
            <TextTitle>Display Ad Import</TextTitle>
          </Modal.Header>
          <Modal.Content>
            <TextContent>Ad imported successfully!</TextContent>
          </Modal.Content>
          <Modal.Actions>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Ok"
              loading={this.state.loading}
              onClick={() => this.onConfirm()}
            />
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  adImport: state.adImport
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AdImport);



// WEBPACK FOOTER //
// ./src/screens/AdImport/AdImport.js